import { render, staticRenderFns } from "./NewProforma.vue?vue&type=template&id=4f762820"
import script from "./NewProforma.vue?vue&type=script&lang=js"
export * from "./NewProforma.vue?vue&type=script&lang=js"
import style0 from "./NewProforma.vue?vue&type=style&index=0&id=4f762820&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports